import React from 'react';
import styled from 'styled-components';

import { X } from '../../Constants/assets';

// TODO: Fix this, this is temporary fix
const InnerContainer = styled.div`
    width: 520px;
    height: 280px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
`;
const Ta = styled.div``;

export default function GeneralInfo() {
    // Stylings
    // small pop up styling
    return (
        <InnerContainer>
            <Ta>test</Ta>
        </InnerContainer>
    );
}
